import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Box, Button, Grid2 } from '@mui/material';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import { BOX_SHADOW } from '../../shared/constants';
import { useCourseDetail } from '../../assets/api/useGetApi';
import { useParams } from 'react-router-dom';
import { TextSkeleton } from '../../shared/utils/SkeletonCom';

const SubscribedCard = () => {
    const { id } = useParams();
    const { data: coursesDetail, isLoading } = useCourseDetail(id);
    return (
        <Card
            sx={{
                boxShadow: BOX_SHADOW,
                border: "1px solid #F0F0F0",
                p: "32px 22px",
                borderRadius: "40px"
            }}>

            <CardContent>
                <Box sx={{ display: "flex", gap: 2 }}>
                    {/* <CutCurrency /> */}

                    <Box
                        sx={{
                            display: "flex",
                            gap: 1,
                            alignItems: "center"
                        }}
                    >
                        <CurrencyRupeeIcon sx={{ color: "red.main", fontSize: "30px" }} />
                        {isLoading && <TextSkeleton width={100} line={1} />}
                        {!isLoading && <Typography variant='h2' fontWeight={500}>{coursesDetail?.data?.price}</Typography>}

                    </Box>
                </Box>
                
                <Box
                    sx={{
                        border: "0.5px solid #000000",
                        borderRadius: "40px",
                        my: 4
                    }}
                >
                    <Grid2 container>
                        <Grid2 children size={6} sx={{ borderRight: "0.5px solid #000000", p: 3 }}>
                            <Typography variant="body2" >Start Date</Typography>
                            {isLoading && <TextSkeleton width={100} line={1} />}
                            {!isLoading && <Typography variant="body2" fontSize={"12px"}>{coursesDetail?.data?.start_date}</Typography>}

                        </Grid2>
                        <Grid2 children size={6} sx={{ p: 3 }}>
                            <Typography variant="body2">End Date</Typography>

                            {isLoading && <TextSkeleton width={100} line={1} />}
                            {!isLoading && <Typography variant="body2" fontSize={"12px"}>{coursesDetail?.data?.end_date}</Typography>}
                        </Grid2>
                    </Grid2>
                    {/* <Box sx={{ p: 3 }}>
                        <Typography variant="body2">No Of Sessions: 28</Typography>
                        <Typography variant="body2" mt={0.5}>
                            Duration Of Session:34 <Typography variant='body2' fontSize={"12px"} component={"span"} color='red.main'>mins/session</Typography>
                        </Typography>
                    </Box> */}
                </Box>

                <Button variant='contained' fullWidth> Subscribe</Button>
               
              
                {isLoading && <TextSkeleton line={1} width={50} margin={"0 auto"} />}
                {!isLoading &&   <Typography variant='body1' fontSize={"12px"} textAlign={"center"} color='red.main' mt={2}>
                {coursesDetail?.data?.title}
                </Typography>}
            </CardContent>
        </Card>
    )
}

export default SubscribedCard